// tippi/src/components/driver/InvoiceProfileCard.js
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { isInvoiceProfileComplete } from '../../utils/invoiceProfile';
import InvoiceProfileForm from './InvoiceProfileForm';
import { COLORS, FONTS } from '../../styles/tokens';

// Sjåførens utbetalings- og fakturaopplysninger i profilen. Må være komplette før sjåføren kan ta eller by på oppdrag.
// embedded: uten eget kort og tittel, til bruk inni en utfoldet profilrad (raden har tittel og status).
export default function InvoiceProfileCard({ embedded = false }) {
  const { userDoc } = useAuth();
  const complete = isInvoiceProfileComplete(userDoc?.invoiceProfile);

  if (embedded) {
    return (
      <div>
        <p style={{ ...styles.text, marginTop: 0 }}>Kontonummeret brukes til utbetaling og står på fakturaene dine.</p>
        <InvoiceProfileForm />
      </div>
    );
  }

  return (
    <section style={styles.card} aria-label="Utbetaling og fakturering">
      <div style={styles.head}>
        <h3 style={styles.title}>Utbetaling og fakturering</h3>
        <span style={{ ...styles.chip, ...(complete ? styles.chipOk : styles.chipMissing) }}>
          {complete ? 'Komplett' : 'Mangler opplysninger'}
        </span>
      </div>
      <p style={styles.text}>
        Kontonummeret brukes til utbetaling og står på fakturaene dine.
      </p>
      <InvoiceProfileForm />
    </section>
  );
}

const styles = {
  card:       { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 20, padding: 18, marginBottom: 14 },
  head:       { display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8 },
  title:      { fontFamily: FONTS.display, fontSize: 24, fontWeight: 700, margin: 0, color: COLORS.textDark },
  chip:       { borderRadius: 20, padding: '3px 10px', fontSize: 11.5, fontWeight: 700, whiteSpace: 'nowrap' },
  chipOk:     { background: COLORS.successBg, color: COLORS.successText },
  chipMissing:{ background: COLORS.warningBg, color: COLORS.warningText },
  text:       { fontSize: 13, color: COLORS.textMid, lineHeight: 1.5, margin: '6px 0 4px' },
};
